import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ToastService } from '../services/toast.service';
import { OrganizationUtilitiesService } from '../utilities/organization-utilities.service';

@Injectable({
  providedIn: 'root'
})
export class OrganizationNotPublicGuard implements CanActivate {
  constructor(
    private orgUtils: OrganizationUtilitiesService,
    private router: Router,
    private toastService: ToastService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.orgUtils.isPublic()) {
      this.toastService.showError('URL not found')
      return this.router.navigateByUrl('/');
    }
    return true;
  }
}
